<ion-spinner name="circular" color="primary"></ion-spinner>
